var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 410,
    viewBox: "0 0 356 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.423828,
    y: 0.472656,
    width: 355.17,
    height: 409.485,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7168,
    y: 31.6812,
    width: 280.584,
    height: 27.6716,
    rx: 5,
    fill: "#D3E1F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7168,
    y: 256.529,
    width: 280.584,
    height: 27.6716,
    rx: 5,
    fill: "#D3E1F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 86.2915,
    width: 176.668,
    height: 6,
    rx: 2,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 312.139,
    width: 161.914,
    height: 6,
    rx: 2,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 161.41,
    width: 151.238,
    height: 6,
    rx: 2,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 103.807,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 114.804,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 125.8,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 136.797,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 328.655,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 339.651,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 350.648,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 361.645,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 178.926,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 189.922,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 200.919,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9609,
    y: 211.916,
    width: 256.271,
    height: 3,
    rx: 1.5,
    fill: "#252B41",
    fillOpacity: 0.53
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 249.232,
    y: 78.406,
    width: 55,
    height: 21.7708,
    fill: "url(#pattern0_337_4097)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 249.232,
    y: 304.254,
    width: 55,
    height: 21.7708,
    fill: "url(#pattern1_337_4097)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 249.232,
    y: 153.525,
    width: 55,
    height: 21.7708,
    fill: "url(#pattern2_337_4097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_337_4097",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_337_4097",
    transform: "scale(0.0104167 0.0263158)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_337_4097",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_337_4097",
    transform: "scale(0.0104167 0.0263158)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_337_4097",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_337_4097",
    transform: "scale(0.0104167 0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_337_4097",
    width: 96,
    height: 38,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAAmCAYAAAA7mZ5JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALoSURBVGhD7ZrPSltBFManXRgrCiXZ1OAigk3bRZFugt12lWfIM7jwCVz4DD6Dz5CVXQqClOKi1AoNtJiN0UKgVTd6v/EejcNNZs79M6eL84PLvROS+cb55syfc312m2AUMZ6nd0UINUAYNUAYNUAYNUAYNUAYNUCYUgwY/uibm38XaSkeErrQG3zdK023sAFozNlJ395jUrXuzdWFGQ76aemR7we7ZvT7MFN3/OfU/o5DIQMwCtAYMB4l4pFGYyzds599Mxre6wDokJari44/+bJrrmMaQJ1AuOWqiKE7N183rbc9O6oJVwcRSIwvT83SyzV7cchtANyfbABAuarRSMTUbSx3TOtdzz5n6cIQ0sV32x827TOH3Aa4jSGqjgIp3Wn1F9X1ZkNprsN1/ffebd+8u9RYM3Mv6qa2ULdlPNNnoUjpAtIkLejO6ujGSueJzqS+j5kGoAHH+ztpqTjvP20HNUpKF9vaaRGWh2a7a5Zfd9NSNjOnIDQ6pOGhhNYlpYuRXibnv/zTk3cNePNxs3Bn4PftDd4CJaHbWu8V1iRQD+rzEfRGDFMCDiA0J3LA3MjtfEJKF9NfHk2Co816JYnTH2fVL9IJk0jocjUJrjZrG8oN0TI6H0joQhOLKAfshrja7HMAJzSLhLFL1bpIJQy+7Znjg52HHNBinXeqhQEA9SAtgcuXG2IZUGaHcoilW0uirNlKto7JBbi69P3matc0XnVsOsMHywDunFjWti6GLjoLHY+UAsE1gHRRF6UxfCawDMj6w7DoYK7E3aUsA/4n3VnkiVSWAZQSALTHxoXTHu7uYplnF5GFhC46M8sAmA5NzPfuxgDf55rAMoByHBDH8d4dffQ5Nc5tYF4kdCdNB9Ak0/EM03G5beFGjf5r4hQwknEIBG5HY5dECzVAxFFKPDTvRKgBOTj6vGVz/9yXL1mwpiDlkVrAFjMEjQBhNAKEUQOEUQOEUQOEUQOEUQOEUQNEMeYOWNDhmtkSm2QAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportExample);
export default __webpack_public_path__ + "static/media/report_example.10081616d3507d31fd551e424580522a.svg";
export { ForwardRef as ReactComponent };